<div class="row details">
  <div class="col-12">
    <div class="row">
      <h4 class="col h4-responsive">Summary</h4>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div class="card card-body">
          <div class="row">
            <div class="col-3">
              <label>Purchaser</label>
            </div>
            <div class="col-9">{{order?.customer}}</div>
          </div>
          <div class="row">
            <div class="col-3">
              <label>Status</label>
            </div>
            <div class="col-9">{{order?.status}}</div>
          </div>
          <div class="row">
            <div class="col-3">
              <label *ngIf="order?.status == 'paid'">Purchased</label>
              <label *ngIf="order?.status != 'paid'">Created</label>
            </div>
            <div class="col-9">{{order?.creation_date| date:'medium'}}</div>
          </div>
          <div class="row">
            <div class="col-3">
              <label>Date Updated</label>
            </div>
            <div class="col-9">{{order?.last_update_date| date:'medium'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row items">
  <div class="col">
    <div class="row">
      <h4 class="col h4-responsive">Item Details</h4>
    </div>
    <div class="card card-body">
      <table class="table table-striped">
        <thead class="secondary-color text-white">
          <th class="w-25">Items</th>
          <th>Price</th>
          <th>Quantity</th>
          <th>Discount</th>
          <th>Total</th>
        </thead>
        <tbody>
          <tr *ngFor="let orderItem of order?.orderItems">
            <td *ngIf="orderItem.type == 'subscription'">
              <label>{{orderItem.item.plan.name}}</label>
            </td>
            <td *ngIf="orderItem.type == 'shop-item'">
              <label>{{orderItem.item.name}}</label>
              <ul *ngIf="orderItem.item.subItems?.length">
                <li *ngFor="let subItem of orderItem.item.subItems">{{subItem.name}}</li>
              </ul>
            </td>
            <td>${{orderItem.price | number:'1.2-2'}}</td>
            <td>x {{orderItem.quantity}}</td>
            <td>
              <span *ngIf="orderItem.discount">-</span>${{orderItem.discount | number:'1.2-2'}}</td>
            <td>${{orderItem.total | number:'1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4">
              <label>Discount Total</label>
            </td>
            <td>
              <span *ngIf="order?.discount">-</span>${{order?.discount | number:'1.2-2'}}</td>
          </tr>
          <tr class="items-total items-total-footer">
            <td colspan="4">
              <label>Payment Total</label>
            </td>
            <td> ${{order?.total | number:'1.2-2'}}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/view-order/view-order.component.html